import { Tag } from '~/src/common/components/Tag/Tag';
import { RecipeType } from '~/src/common/typings/product';

const TypeTag = ({ recipeType }: { recipeType: RecipeType }) => (
  <Tag bgColor={recipeType.bgColor} fgColor={recipeType.fgColor}>
    {recipeType.label}
  </Tag>
);

export default TypeTag;
